import { API_CONFIG } from '@/lib/config/api.config';
import {
  Lawyer,
  Profile,
  ProfileFiltersValues,
  User,
} from '@/lib/models/client.types';
import { apiService } from '@/lib/services/api.service';
import { Session } from 'next-auth';

type LawyersResponse = {
  data: Lawyer[];
  meta: {
    limit: number;
    page: number;
    total: number;
    totalPages: number;
  };
};

class ProfileService {
  async updateLanguage(userId: string, language: string, session: Session) {
    return apiService.patch<Profile>(
      API_CONFIG.ENDPOINTS.PROFILE.UPDATE(userId),
      { language },
      session
    );
  }

  async getProfile(userId: string, session: Session) {
    return apiService.get<Profile>(
      `${API_CONFIG.ENDPOINTS.PROFILE.BASE}/user/${userId}`,
      session
    );
  }

  async createProfile(userId: string, session: Session) {
    const user = await apiService.get<User>(
      API_CONFIG.ENDPOINTS.USERS.BASE,
      session
    );

    if (user?.role !== 'lawyer') return null;

    return apiService.post<Profile>(
      API_CONFIG.ENDPOINTS.PROFILE.BASE,
      { userId },
      session
    );
  }

  async updateProfile(
    userId: string,
    data: Partial<Profile>,
    session: Session
  ) {
    return apiService.patch<Profile>(
      API_CONFIG.ENDPOINTS.PROFILE.UPDATE(userId),
      data,
      session
    );
  }

  async getProfileFiltersValues(session: Session | null) {
    if (!session) return null;
    return apiService.get<ProfileFiltersValues>(
      API_CONFIG.ENDPOINTS.PROFILE.FILTERS,
      session
    );
  }

  async getLawyers(session: Session | null, params: string) {
    if (!session) return null;
    return apiService.get<LawyersResponse>(
      `${API_CONFIG.ENDPOINTS.PROFILE.BASE}?${params}`,
      session
    );
  }

  async getLawyerById(session: Session | null, id: string) {
    if (!session) return null;
    return apiService.get<Lawyer>(
      `${API_CONFIG.ENDPOINTS.PROFILE.BASE}/${id}`,
      session
    );
  }
}

export const profileService = new ProfileService();
